var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngageAPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_209_67347)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7984 21.0069C20.7498 21.0069 18.2695 18.5267 18.2695 15.4781C18.2695 12.4295 20.7498 9.94922 23.7984 9.94922C26.847 9.94922 29.3272 12.4295 29.3272 15.4781C29.3272 18.5267 26.847 21.0069 23.7984 21.0069Z",
    fill: "#F16480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1203 22.0863C20.4404 23.0139 22.048 23.559 23.7805 23.559C25.5131 23.559 27.1208 23.0138 28.4411 22.0859C31.8885 23.801 34.2574 27.3595 34.2574 31.4713V44.0857H14.5875C13.879 44.0857 13.3047 43.5113 13.3047 42.8029V31.4713C13.3047 27.3598 15.6732 23.8014 19.1203 22.0863Z",
    fill: "url(#paint1_linear_209_67347)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1914 43.1214V37.3085C20.1914 36.8016 20.6219 36.3906 21.1529 36.3906C21.684 36.3906 22.1145 36.8016 22.1145 37.3085V43.1214",
    fill: "#D2536C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3516 28.1133V33.5142C28.3516 33.8652 28.7192 34.0948 29.0346 33.9408L29.3648 33.7796L31.079 32.4013L32.7931 33.7796L33.1233 33.9408C33.4387 34.0948 33.8063 33.8652 33.8063 33.5142V28.1153L28.3516 28.1133Z",
    fill: "#F2E9E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3633 28.5039V35.2266L31.0775 34.3895L32.7916 35.2266V28.5051L29.3633 28.5039Z",
    fill: "#F16480",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3756 28.8278C31.3904 30.5513 27.5598 29.5248 25.8362 26.5397C24.1128 23.5545 25.1393 19.7239 28.1244 18.0004C31.1095 16.2769 34.9402 17.3033 36.6637 20.2885C38.3872 23.2736 37.3608 27.1043 34.3756 28.8278Z",
    fill: "url(#paint2_linear_209_67347)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2488 27.7398C33.6385 27.7398 35.5757 25.8026 35.5757 23.4129C35.5757 21.0232 33.6385 19.0859 31.2488 19.0859C28.8591 19.0859 26.9219 21.0232 26.9219 23.4129C26.9219 25.8026 28.8591 27.7398 31.2488 27.7398Z",
    fill: "#F16480",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4334 25.6865L33.3194 24.5773L29.834 22.0977L28.7998 22.3199C28.3854 22.409 28.2218 22.9124 28.5047 23.228L29.285 24.0986C29.3888 24.2145 29.439 24.3687 29.4231 24.5235L29.3035 25.6865C29.2601 26.1081 29.6884 26.4193 30.076 26.2477L31.145 25.7746C31.2873 25.7116 31.4496 25.7116 31.5918 25.7746L32.6609 26.2477C33.0485 26.4193 33.4768 26.1081 33.4334 25.6865Z",
    fill: "#F16480",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9352 22.3217L32.7922 22.076C32.6401 22.0434 32.5088 21.948 32.4307 21.8134L31.8439 20.8023C31.6312 20.4357 31.1018 20.4357 30.8891 20.8023L30.3023 21.8134C30.2242 21.948 30.0929 22.0434 29.9408 22.076L29.832 22.0994C30.0505 23.5309 31.2869 24.6276 32.7795 24.6276C32.9632 24.6276 33.1429 24.6109 33.3174 24.579L33.3119 24.5252C33.296 24.3705 33.3461 24.2162 33.4499 24.1003L34.2303 23.2297C34.5131 22.9142 34.3495 22.4107 33.9352 22.3217Z",
    fill: "#F16480"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_67347",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 45.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_67347",
    x1: 23.781,
    y1: 22.0859,
    x2: 23.781,
    y2: 33.0276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_67347",
    x1: 31.25,
    y1: 17.1641,
    x2: 31.25,
    y2: 29.6641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE5E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngageAPro);
export default __webpack_public_path__ + "static/media/engage-a-pro.51f8c7cc5be5f6ddce6c00fddc9b7175.svg";
export { ForwardRef as ReactComponent };